import { render, staticRenderFns } from "./PaymentInstructionPropertyDialog.vue?vue&type=template&id=5d06b418&"
import script from "./PaymentInstructionPropertyDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionPropertyDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports